import React from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loading from '../../components/Loading';

function TaskListDataset({ listaDeElementos }) {
  // const listaDeElementos = [
  //   { id: 1, texto: 'Elemento 1' },
  //   { id: 2, texto: 'Elemento 2' },
  //   { id: 3, texto: 'Elemento 3' },
  //   { id: 4, texto: 'Elemento 4' }
  // ];
  const openInNewTab = url => {
    window.open(url, '_blank').focus();
  };
  return (
    <ListGroup className="mx-5 pt-3" style={{ width: '100%' }}>
      {listaDeElementos.map(elemento => (
        <ListGroup.Item key={elemento.id} style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <span>{elemento.name}</span>
            <div>
              {elemento.progress && !elemento.error && (
                <Button variant="info" onClick={() => openInNewTab(elemento.link)}>
                  Result
                </Button>
              )}
              {!elemento.progress && !elemento.error && <Loading />}
              {elemento.error && (
                <FontAwesomeIcon
                  icon="exclamation-triangle"
                  style={{ color: '#ff7b00' }}
                  size="lg"
                />
              )}
            </div>
          </div>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
}
TaskListDataset.defaultProps = {
  listaDeElementos: []
};

TaskListDataset.propTypes = {
  listaDeElementos: PropTypes.array
};

export default TaskListDataset;
